module.exports = __webpack_public_path__ + "img/pumpjack-horsehead.9182f35f.png";